// themes.js
export const lightTheme = {
  background: '#fff',
  text: '#222',
  headerBg: '#fff',
  headerText: '#224abe',
  footerBg: '#eee',
  footerText: '#222',
  linkHoverBg: '#e1e7ff',
  sidebarGradient: 'linear-gradient(180deg, #4e73df, #224abe)',
  sidebarText: '#fff',
  sidebarLink: '#cbd5ff',
  sidebarLinkHover: '#fff',
  sidebarHover: 'rgba(255, 255, 255, 0.15)',
  sidebarToggleBg: 'rgba(255, 255, 255, 0.1)',
  sidebarToggleHoverBg: 'rgba(255, 255, 255, 0.2)',
  tocBg: '#f7f7f7',
  tocBorder: '#ddd',
  tocText: '#333',
  tocLink: '#005a9c',
  tocLinkHover: '#003f73',
  inlineCodeBackground: '#e8e8e8',
  inlineCodeText:'#c0392b',
  codeBackground:'#f8f8f8',
  codeText:'#333',
  accent:'#007bff',
  tableStriping:'#F5F5F5',
  tableHover:'#E0E0FF',
};

export const darkTheme = {
  background: '#0f172a',
  text: '#e0e7ff',
  paragraphText: 'white',
  headerBg: '#1e293b',
  headerText: '#93c5fd',
  footerBg: '#1e293b',
  footerText: '#cbd5e1',
  link: '#93c5fd',
  linkHover: '#334155',
  sidebarGradient: 'linear-gradient(180deg, #1e293b, #0f172a)',
  sidebarText: '#cbd5e1',
  sidebarLink: '#93c5fd',
  sidebarLinkHover: '#ffffff',
  sidebarHover: 'rgba(255, 255, 255, 0.08)',
  sidebarToggleBg: 'rgba(255, 255, 255, 0.04)',
  sidebarToggleHoverBg: 'rgba(255, 255, 255, 0.12)',
  buttonBg: '#334155',
  buttonHoverBg: '#475569',
  homeBg: 'linear-gradient(to bottom right, #1e293b, #0f172a)',
  welcomeText: '#e0e7ff',
  taglineText: '#94a3b8',
  exploreButtonBg: '#3b82f6',
  exploreButtonHoverBg: '#2563eb',
  popupBg: '#1e1e1e',
  popupText: '#eee',
  popupCloseBg: '#555',
  tocBg: '#1e1e1e',
  tocBorder: '#333',
  tocText: '#ddd',
  tocLink: '#4ea1ff',
  tocLinkHover: '#82cfff',
  headerText2: '#b0bfff', 
  inlineCodeBackground:'#363636',
  inlineCodeText:'#8be9fd',
  codeBackground:'#2a2a2a',
  codeText:'#a0a0a0',
  accent:'#FFA500',
  tableStriping:'#2a2a2a',
  tableHover:'#383838',
  linkText: '#ddd',
};